import * as React from "react";
import { Create, List, Datagrid, TextField, EditController, required, regex, EmailField, TextInput, Filter, NumberField, FunctionField, Edit, SimpleForm, EditButton, Show, SimpleShowLayout, ShowButton, ArrayField, RefreshButton, ReferenceField, SaveButton, Toolbar } from 'react-admin';
import { cloneElement } from 'react';
import {
    useListContext,
    TopToolbar,
    ExportButton,
    sanitizeListRestProps,
    CreateButton,
    SelectInput,
    PasswordInput,
    usePermissions,
    BooleanField
} from 'react-admin';
import DeleteButtonWithConfirmation from '../buttons/deleteButtonWithConfirmation'
import UnDeleteButtonWithConfirmation from '../buttons/UndeleteButtonWithConfirmation'
import DeletePermButtonWithConfirmation from '../buttons/deletePermButtonWithConfirmation'
import ButtonPassForm from '../buttons/sendPasswordForm';
import ButtonVerifyForm from '../buttons/sendVerifyForm';
// import ValidateUserButton from '../buttons/validateUser'
// import { Redirect } from 'react-router';


const UserTitle = ({ record, optionTitle }) => {
    if (optionTitle) {
        return ""
    }
    return <span>Cliente - {record ? `${record.firstname} ${record.lastname}` : ''}</span>;
};

const ShowActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        basePath,
        data,
        resource,
        ...rest
    } = props;
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {permissions.includes("transactions.list") &&
                <RefreshButton label="Buscar transacciones" />
            }
            {permissions.includes("users.validate") &&
                (data !== undefined && !(data.validated || (!data.validated && data.balance !== null))) ? <ButtonVerifyForm record={data} label="Enviar link confirmación" />
                : null}
            {permissions.includes("users.change_pass") &&
                <ButtonPassForm basePath={basePath} record={data} label="Cambiar contraseña" />
            }
            {permissions.includes("users.edit") &&
                <EditButton basePath={basePath} record={data} label="Editar" />
            }
            {permissions.includes("users.block") &&
                ((data !== undefined && !data.blocked) ? <DeleteButtonWithConfirmation basePath={basePath} record={data} resource={resource} undoable={false} label="Bloquear" /> : <></>)
            }
            {permissions.includes("users.block") &&
                ((data !== undefined && data.blocked) ? <UnDeleteButtonWithConfirmation basePath={basePath} record={data} resource={resource} undoable={false} label="Desbloquear" /> : <></>)
            }
            {permissions.includes("users.delete") &&
                <DeletePermButtonWithConfirmation basePath={basePath} record={data} resource={resource} undoable={false} label="Eliminar" />
            }
        </TopToolbar>
    );
};

const EditActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        basePath,
        data,
        resource,
        permissions,
        ...rest
    } = props;
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            <ShowButton basePath={basePath} record={data} label="Ver usuario" />
        </TopToolbar>
    );
};

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        basePath,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        showFilter,
        total,
    } = useListContext();
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            {permissions.includes("users.create") &&
                <CreateButton basePath={basePath} label="Crear" />
            }
            {permissions.includes("users.export") &&
                <ExportButton
                    label="Exportar csv"
                    disabled={total === 0}
                    resource={resource}
                    sort={currentSort}
                    filterValues={filterValues}
                    maxResults={maxResults}
                />
            }
            {/* Add your custom actions */}
        </TopToolbar>
    );
};

export const UserList = props => (
    <List filters={<UserFilter />} {...props} bulkActionButtons={false} title="Usuarios" actions={<ListActions />}>
        <Datagrid rowClick={(id, _, record) => {
            return (record.role !== "USER" && record.role !== "postgres") ? `/staff/${id}/show` : `/users/${id}/show`
        }}>
            <ShowButton label="Ver" />
            {/* <TextField source="id" /> */}
            <FunctionField label="Nombre completo" render={record => `${record.firstname} ${record.lastname}`} />
            <TextField source="username" label='Usuario' />
            <EmailField source="email" label='Correo electrónico' />
            <NumberField source="rut" label='RUT' />
            <NumberField source="phone" label='Teléfono' />
            <NumberField source="balance" label='Balance actual' />
            <FunctionField label="Validada" render={record => (record.validated || (!record.validated && record.balance !== null)) ? 'Sí' : 'No'} />
            <TextField source="createdAt" label="Fecha creación" />
            <EditButton label="Editar" />
        </Datagrid>
    </List>
);

const UserEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

export const UserEdit = props => {
    return (
        <EditController {...props}>
            {controllerProps => {
                const { record } = controllerProps;
                return (
                    <Edit title={<UserTitle />} {...props} actions={<EditActions />} >
                        <SimpleForm toolbar={<UserEditToolbar />} >
                            {/* <TextInput disabled source="id" /> */}
                            <TextInput source="firstname" label="Nombre" />
                            <TextInput source="lastname" label="Apellido" />
                            {/* <TextInput source="email" label='Correo electrónico' type="email" /> */}
                            {/* <TextField source="lastTransaction" label='Última transacción' /> */}
                            {(record && record.role === 'postgres') ? <SelectInput source="role" label="Rol" defaultValue="postgres" choices={[
                                { id: 'USER', name: 'Usuario' },
                                { id: 'TECH', name: 'Personal' }
                            ]} /> :
                                <SelectInput source="role" label="Rol" defaultValue="user" choices={[
                                    { id: 'USER', name: 'Usuario' },
                                    { id: 'TECH', name: 'Personal' }
                                ]} />}
                        </SimpleForm>
                    </Edit>
                );
            }}
        </EditController>
    )
};

export const UserCreate = props => (
    <Create title={<UserTitle optionTitle={true} />} {...props}>
        <SimpleForm submitOnEnter={false} toolbar={<UserEditToolbar />} >
            <TextInput helperText={"Entre 2 y 30 caracteres, sin espacios y sin caracteres especiales. "} validate={[required(), regex(/^^[a-zA-Z0-9_]{2,31}$/)]} source="username" label="Usuario" inputProps={{ autocomplete: 'off' }} />
            <TextInput helperText={"Entre 2 y 40 caracteres."} validate={[required(), regex(/^^[a-zA-ZñÑ0-9 -]{2,41}$/)]} source="name" label="Nombre" />
            <TextInput helperText={"Entre 2 y 40 caracteres."} validate={[required(), regex(/^^[a-zA-ZñÑ0-9 -]{2,41}$/)]} source="lastname" label="Apellido" />
            <TextInput helperText={"Debe ser un correo único."} validate={[required(), regex(/^^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]} source="email" label='Correo electrónico' type="email" />
            <PasswordInput helperText={"Al menos 8 caracteres entre mayúsculas, minúsculas y números."} validate={[required(), regex(/^^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,50}$/)]} source="password" label='Contraseña' inputProps={{ autocomplete: 'off' }} />
            <SelectInput validate={[required()]} source="userType" label="Tipo de usuario" choices={[
                { id: 'usuario', name: 'Usuario normal' },
                { id: 'tecnico', name: 'Personal' }
            ]} />
        </SimpleForm>
    </Create>
);

export const UserShow = props => {
    let roles = {
        user: 'Usuario',
        USER: 'Usuario',
        tech: 'Técnico',
        TECH: 'Técnico',
        postgres: 'Usuario',
        ASEO: "Aseo",
        SUPER_ADMIN: "Super administrador",
        ADMIN: "Administrador",
        FINANZAS: "Finanzas",
        PERSONALIZADO: "Personalizado"
    };
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <Show title={<UserTitle />} {...props} actions={<ShowActions />} >
            <SimpleShowLayout>
                {/* <TextField source="id" /> */}
                {/* {!props.record.validated ? <ValidateUserButton /> : <></>} */}
                <EmailField source="email" label='Correo electrónico' type="email" />
                <TextField source="username" label='Usuario' />
                <TextField source="rut" label='Rut' />
                <TextField source="phone" label='Teléfono' />
                <FunctionField label="Rol" render={record => (record.role) ? roles[record.role] : record.role} />
                {permissions.includes("transactions.list") &&
                    <ReferenceField source="lastTransaction" label='Última transacción' reference="transactions">
                        <FunctionField label="Tipo de transacción" render={record => `${record.transactionType.toUpperCase()} - $${record.amount} - ${record.createdAt}`} link="show" />
                    </ReferenceField >
                }
                <NumberField source="balance" label='Balance actual' />
                <FunctionField label="Validada" render={record => (record.validated || (!record.validated && record.balance !== null)) ? 'Sí' : 'No'} />
                {permissions.includes("transactions.list") &&
                    <ArrayField source="transactions" label="Transacciones (se muestran las últimas 25 transacciones)">
                        <Datagrid>
                            <ShowButton label="Ver" basePath="/transactions" />
                            <NumberField source="transactionId" label="Id" />
                            <TextField source="amount" label="Monto" />
                            <TextField source="machineId" label="Máquina" />
                            <FunctionField render={record => {
                                if (record.role === 'USER' || record.role === 'postgres') {
                                    return `${record.transactionType.toUpperCase()}`;
                                } else {
                                    if (record.transactionType === 'pago') {
                                        return 'USO PERSONAL';
                                    }
                                    return `${record.transactionType.toUpperCase()}`;
                                }
                            }} label="Tipo de transacción" />
                            <TextField source="createdAt" label="Fecha" />
                            <NumberField source="balance" label="Balance al momento" />
                            <BooleanField source="ignored" label="Ignorado (no lo ve el usuario)" />
                        </Datagrid>
                    </ArrayField>
                }
                {permissions.includes("transactions.list") &&
                    <button onClick={() => props.history.push(`/transactions?page=1&perPage=25&filter={"userId":"${props.id}"}`)}>Mostrar más transacciones</button>
                }
            </SimpleShowLayout>
        </Show>
    )
};

const UserFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="q" alwaysOn />
        {/* <SelectInput source="role" label="Rol" choices={[
            { id: 'USER', name: 'Usuario' },
            { id: 'TECH', name: 'Técnico' },
            { id: 'ASEO', name: 'Aseo' },
            { id: 'FINANZAS', name: 'Finanzas' },
            { id: 'PERSONALIZADO', name: 'Personalzado' },
            { id: 'ADMIN', name: 'Administrador' },
            { id: 'SUPER_ADMIN', name: 'Súper administrador' },
        ]} /> */}
    </Filter>
);
